import { render } from "./Navbar.vue?vue&type=template&id=2ef787ec"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=2ef787ec&lang=css"
script.render = render

export default script